import React from 'react';
import Head from 'next/head';
import { BootstrapLoadingWrapper } from 'components/BootstrapLoadingWrapper';
import { metaDescription } from 'utils/metaTags';
import { JoinScreen } from 'screens/Join/JoinScreen';

export default function Join() {
  return (
    <>
      <Head>
        <title>{'Hevy Coach - Join'}</title>
        <meta name="description" content={metaDescription} />
      </Head>
      <BootstrapLoadingWrapper>
        <JoinScreen />
      </BootstrapLoadingWrapper>
    </>
  );
}
